export default "__VITE_ASSET__C6n3kai0__"